import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@p2p/shared/utils';
import { Observable } from 'rxjs';

import { CommonSettingsResponse, CommonSettingsUnionKeys } from '../entities/common-settings';

@Injectable({ providedIn: 'root' })
export class CommonSettingsDataService {
    private readonly http = inject(HttpClient);

    private readonly url = '/rest/default-settings/common-settings';

    getCommonSettings(): Observable<CommonSettingsResponse> {
        return this.http.get<CommonSettingsResponse>(`${environment.apiUrl}${this.url}`);
    }

    updateCommonSettings(commonSettings: CommonSettingsUnionKeys): Observable<void> {
        return this.http.put<void>(`${environment.apiUrl}${this.url}/update`, commonSettings);
    }
}
